import { Dispatch, Store, bindActionCreators } from "redux";
import { connect } from "react-redux";

import EditView, {
    StateProps as EditViewStateProps,
    DispatchProps as EditViewDispatchProps
} from "./components/EditView";

import {BackgroundSettings} from './state';
import {ModuleSectionData, ToggleGroups} from './data/payload';
import {serializeBackgroundSettings} from './data/serialization';
import {
    updatePayload, toggleManageGroups, changeBackgroundImage,
    addGroupAction, supportsAddGroup, isModuleLimitReached,
    openAviarySection
} from './index';

import {SectionKpiEventsTypes, emitKpiEvent} from "./tracking";
import {
    changeBackgroundImage as changeGroupBackgroundImage,
    changeBackgroundSettings as changeGroupBackgroundSettings
} from "../sectionContainer/index";
import {AppState} from 'diy/redux/app/state';
import {toggleElementsMenu, toggleBackgroundMenu} from './index';

export function changeLayout(layoutName: string) {
    return (dispatch: Dispatch, getState: () => AppState) => {
        emitKpiEvent(SectionKpiEventsTypes.LayoutChanged, layoutName);
        dispatch(updatePayload({layout: layoutName} as ModuleSectionData));
    };
}

function changeFullWidth(fullWidth: boolean) {
    emitKpiEvent(SectionKpiEventsTypes.FullWidthChanged, fullWidth ? "On" : "Off");
    return updatePayload({
            fullWidth: fullWidth ? 1 : 0
        } as ModuleSectionData
    );
}

function changeToggles(toggles: ToggleGroups[]) {
    emitKpiEvent(SectionKpiEventsTypes.ToggleContent);
    return updatePayload({
            toggles
        } as ModuleSectionData
    );
}

function changeBackgroundSettings(background: BackgroundSettings) {
    let newBackground = serializeBackgroundSettings(background);

    return updatePayload({ background: newBackground } as ModuleSectionData);
}

// ======================
// CONNECT REACT TO REDUX
// ======================
function mapStateToProps(state: AppState): EditViewStateProps {
    const ownState = state.moduleSection;
    const containerState = state.moduleSectionContainer;

    return {
        toggles: ownState.toggles,
        fullWidth: ownState.fullWidth,
        isFullWidthAvailable: ownState.isFullWidthAvailable,
        availableLayouts: ownState.availableLayouts,
        layout: ownState.layout,
        background: ownState.background,
        manageGroupsActive: ownState.manageGroupsActive,
        isManageGroupsAvailable: ownState.configurableGroups.length > 0,
        isAddGroupAvailable: supportsAddGroup(ownState),
        canAddGroup: ownState.quantity.current < ownState.quantity.max && ! isModuleLimitReached(),
        canDeleteGroup: ownState.quantity.current > ownState.quantity.min,
        configurableGroups: containerState.configurableGroups,
        groupBackgroundMap: containerState.backgroundSettings,
        configurableGroupIds: ownState.configurableGroups,
        elementsMenuVisible: ownState.elementsMenuVisible,
        backgroundMenuVisible: ownState.backgroundMenuVisible
    };
};

function mapDispatchToProps(dispatch: Dispatch): EditViewDispatchProps {
    return bindActionCreators<EditViewDispatchProps>({
        onChangeLayout: changeLayout,
        onChangeFullWidth: changeFullWidth,
        onChangeToggles: changeToggles,
        onBackgroundChange: changeBackgroundSettings,
        onBackgroundImageChange: changeBackgroundImage,
        onManageGroupsToggle: toggleManageGroups,
        onAddGroup: addGroupAction,
        onChangeGroupBackgroundImage: changeGroupBackgroundImage,
        onChangeGroupBackground: changeGroupBackgroundSettings,
        onElementsMenuToggle: toggleElementsMenu,
        onBackgroundMenuToggle: toggleBackgroundMenu,
        onEditImageClicked: openAviarySection,
        onSelectImageClicked: () => toggleBackgroundMenu({visible: false})
    }, dispatch);
}

export function getEditViewComponent(store: Store) {
    const ConnectedEditView = connect(mapStateToProps, mapDispatchToProps)(EditView);

    return ConnectedEditView;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/basicTab.ts
 **/